export const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : ''
export const slugToLabel = (slug) => slug.split('_').map(capitalize).join(' ')
export const kebabToLabel = (slug) => slug.split('-').map(capitalize).join(' ')
export const kebabToCamel = (str) =>
  str.replace(/-([a-z])/g, (g) => g[1].toUpperCase())
export const camelToLabel = (str) =>
  str
    ? str
        .replace(/([A-Z])/g, ' $1')
        .trim()
        .replace(/^./, (c) => c.toUpperCase())
    : ''
